module.exports = __webpack_public_path__ + "img/dementia-01-risk-factor.73bb8d12.jpg";